import { render, staticRenderFns } from "./DoctorAtHand.vue?vue&type=template&id=cbec4b46"
import script from "./DoctorAtHand.vue?vue&type=script&lang=js"
export * from "./DoctorAtHand.vue?vue&type=script&lang=js"
import style0 from "./DoctorAtHand.vue?vue&type=style&index=0&id=cbec4b46&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports